const ROIIFY_SDK_URL = 'https://www.roiify.net/sdk/roiify-ads.js'

let sdkPromise = null

function loadRoiifySdk() {
  if (globalThis.RoiifyAds?.show) return Promise.resolve(globalThis.RoiifyAds)
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${ROIIFY_SDK_URL}"]`)
    const script = existing || document.createElement('script')
    const timeout = window.setTimeout(() => reject(new Error('Roiify SDK load timed out')), 10000)

    const handleLoad = () => {
      window.clearTimeout(timeout)
      if (globalThis.RoiifyAds?.show) resolve(globalThis.RoiifyAds)
      else reject(new Error('Roiify SDK did not expose RoiifyAds.show'))
    }
    const handleError = () => {
      window.clearTimeout(timeout)
      reject(new Error('Roiify SDK failed to load'))
    }

    script.addEventListener('load', handleLoad, { once: true })
    script.addEventListener('error', handleError, { once: true })
    if (!existing) {
      script.src = ROIIFY_SDK_URL
      script.async = true
      script.referrerPolicy = 'strict-origin-when-cross-origin'
      document.head.appendChild(script)
    }
  })

  return sdkPromise
}

class RoiifyBanner {
  constructor(options = {}) {
    this.placementId = String(options.placementId || '').trim()
    this.theme = options.theme === 'light' ? 'light' : 'dark'
    this.region = document.getElementById(options.regionId || 'roiify-ad-region')
    this.slotSelector = options.slotSelector || '#roiify-ad-slot'
  }

  isConfigured() {
    return /^plc_[A-Za-z0-9_-]+$/.test(this.placementId)
  }

  prepare() {
    if (!this.region || !this.isConfigured()) return false
    this.region.hidden = false
    return true
  }

  async load() {
    if (!this.prepare()) return { ok: false, reason: 'not_configured' }
    try {
      const roiify = await loadRoiifySdk()
      await Promise.resolve(
        roiify.show(this.placementId, this.slotSelector, {
          theme: this.theme,
          format: 'banner'
        })
      )
      return { ok: true }
    } catch (error) {
      console.warn('[Roiify] Banner unavailable:', error)
      return { ok: false, reason: 'load_failed', error }
    }
  }
}

module.exports = { RoiifyBanner, loadRoiifySdk }
